import { NgClass, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppNavigationComponent } from '@layout/components/app-navigation/app-navigation.component';
import { LayoutService } from '@layout/core/services';
import { ButtonIconComponent } from '@shared-features/buttons/button-icon/button-icon.component';
import { AppRoutes } from '@shared/enums';
import { DrawerModule } from 'primeng/drawer';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    imports: [DrawerModule, AppNavigationComponent, NgClass, NgOptimizedImage, ButtonIconComponent, RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarComponent {
    isCollapsed = signal<boolean>(true);

    constructor(private layoutService: LayoutService) {
        this.layoutService.isSidebarCollapsed$.subscribe((isCollapsed: boolean) => {
            this.isCollapsed.set(isCollapsed);
        });
    }

    toggleIsCollapsed(): void {
        this.layoutService.toggleSidebar();
    }

    protected readonly appRoutes = AppRoutes;
}
